import { action, computed, makeObservable, observable } from 'mobx'

import BaseProductStore from 'supplier/stores/BaseProductStore'

class ProductStore extends BaseProductStore {
  @observable uuid
  @observable clearanceErrors
  @observable syncMeta
  @observable syncErrors
  @observable selected = false

  constructor (data = {}) {
    super()
    makeObservable(this)
    this.update(data)
  }

  @action.bound
  setSelected (value) {
    this.selected = value
  }

  @computed get isSynced () {
    return !!this.syncMeta?.syncEnabled
  }
}

export default ProductStore
